module.exports = __webpack_public_path__ + "media/images/icon__info--rb-gray@2x-f6cf82eb02a528edf915f5450e69035b.png";